export const createIMCDraftRequest = (params) => {
    ////console.log('createIMCDraftRequest.params', params);
    return {
        type: 'IMCDraftSave',
        payload: params,
    };
};

export const createClientDraftRequest = (params) => {
    ////console.log('createClientDraftRequest.params', params);
    return {
        type: 'ClientDraftSave',
        payload: params,
    };
};
